import { __awaiter } from "tslib";
import { sendCredential } from 'src/components/main/#services/socialAuth';
import { showAlert } from 'src/components/main/#common/alert/store';
if (typeof window !== 'undefined') {
    window.oauthGoogleCallback = function oauthGoogleCallback(response) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield sendCredential.request({
                    data: {
                        provider: 'google',
                        credential: response.credential,
                    },
                });
            }
            catch (err) {
                console.error(err);
                if (err.message.includes('ban')) {
                    showAlert.set({
                        status: 'error',
                        text: 'Your Account Has Been Banned',
                    });
                }
                else {
                    showAlert.set({
                        status: 'error',
                        text: 'Google authorization error',
                    });
                }
            }
        });
    };
}
